import React from 'react'

export interface WordmarkProps {
  size?: number
  tone?: 'default' | 'inverse'
}

export default function Wordmark({
  size = 28,
  tone = 'default'
}: WordmarkProps): React.JSX.Element {
  return (
    <span
      style={{
        fontFamily: "'Playfair Display', serif",
        fontWeight: 700,
        fontSize: `${size}px`,
        whiteSpace: 'nowrap'
      }}
    >
      <span style={{ color: '#5b7fff' }}>9</span>
      <span style={{ color: tone === 'inverse' ? 'var(--nn-ivory)' : 'var(--text-heading)' }}>
        nights
      </span>
    </span>
  )
}
